import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { validation, validateForm } from '../../../../utils/validation';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { EmployeeContext } from '../../../../contextProvider/employeeProvider';
import {
  profileApi,
  profileDepartmentApi,
  usersApi,
  roleApi,
} from '../../../../services/apis';
import {
  ValidationMessage,
  Input,
  Button,
  Dropdown,
  Confirmation,
  DepartmentManagement,
  MultiSelectDropDown,
  Toast,
  Modal,
  Tooltip,
} from '../../../../component';
import './inviteEmployee.scss';

const INITIAL_DATA = {
  profileId: '',
  id: '',
  email: '',
  fullName: '',
  roleId: 0,
  roleName: [{}],
  departmentId: 0,
  description: '',
};

class InviteEmployee extends Component {
  static contextType = EmployeeContext;
  constructor(props) {
    super(props);
    this.state = {
      data: structuredClone(INITIAL_DATA),
      departmentList: [],
      roleList: [],
      errors: {},
      alertMessage: 'profile.invitesuccessfully',
      toastState: 'success',
      loading: false,
      showModal: false,
      toast: false,
    };
  }

  async componentDidMount() {
    const { id } = this.props;
    const {
      payload: { data: roleData },
    } = await roleApi.getAll();
    const {
      payload: { data: departemantData },
    } = await profileDepartmentApi.getAllByProfileId({
      profileId: id,
      pageNumber: 1,
      itemPerPage: 20,
    });
    this.setState({
      departmentList: departemantData.rows,
      roleList: roleData,
    });
  }

  fetchFullEmployeeName = async (email) => {
    let { data } = this.state;
    try {
      const { payload } = await usersApi.getNameByUsername({ username: email });
      if (payload?.data?.length) {
        const {
          individualProfile: { firstName = '', lastName = '' },
        } = payload?.data[0];
        data.fullName = `${firstName} ${lastName}`;
      } else data.fullName = '';
      this.setState({
        data,
      });
    } catch (error) {
      if (error.status === 404) {
        data.fullName = '';
        this.setState({
          data,
        });
      } else {
        this.setState({
          toast: true,
          toastState: 'danger',
          alertMessage: 'error.receiveerror',
        });
      }
    }
  };

  fetchDepartmentList = async () => {
    const { id } = this.props;
    try {
      const {
        payload: { data },
      } = await profileDepartmentApi.getAllByProfileId({
        profileId: id,
        pageNumber: 1,
        itemPerPage: 20,
      });
      this.setState({
        departmentList: data.rows,
        toast: true,
        alertMessage: 'department.departmentadd',
        toastState: 'success',
      });
    } catch (error) {
      this.setState({
        toast: true,
        toastState: 'danger',
        alertMessage: 'error.receiveerror',
      });
    }
  };

  handleInviteEmployee = async () => {
    const { email, roleId, departmentId } = this.state.data,
      { id } = this.props;
    this.setState({
      loading: true,
    });
    try {
      await profileApi.inviteEmployee({
        data: {
          email: email,
          profileId: parseInt(id),
          roleId: roleId,
          departmentId: parseInt(departmentId),
        },
      });
      this.setState({
        data: structuredClone(INITIAL_DATA),
        fullName: '',
        toast: true,
        toastState: 'success',
        alertMessage: 'profile.invitesuccessfully',
      });
    } catch (error) {
      error.status === 403
        ? (message = 'booking.accessdenied')
        : error.status === 400
        ? (message = 'forgetpassword.wrongemail')
        : (message = 'booking.servererror');
      this.setState({
        toast: true,
        alertMessage: message,
        toastState: 'danger',
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  validate = () => {
    const { email, departmentId, roleId, description } = this.state.data;
    const { error, result } = validateForm({
      email: validation.email(email).required().errors,
      departmentId: validation.required(departmentId).errors,
      roleId: validation.array(roleId).required().errors,
      description: validation.optional(description).errors,
    });
    return { result, error };
  };

  searchEmployee = async (phrase) => {
    const { errors, data } = this.state;
    data.email = phrase;
    data.fullName = '';
    this.setState(
      {
        data,
        errors: {
          ...errors,
          ['userName']: this.validate().error['email'],
        },
      },
      () => {
        if (this.state.errors?.userName?.length === 0) {
          setTimeout(() => {
            this.fetchFullEmployeeName(phrase);
          }, 500);
        }
      },
    );
  };

  handleChange = (event) => {
    const { errors } = this.state;
    const { currentTarget: input } = event;
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data, [input.name]: input.value }, () => {
      this.setState({
        errors: {
          ...errors,
          [input.name]: this.validate().error[input.name],
        },
      });
    });
  };

  handleMultiSelectChange = ({ stateName, value }) => {
    let { data } = this.state;
    const valueArray = value?.map(({ id }) => id);
    data[stateName] = valueArray;
    this.setState({ data });
  };

  render() {
    const {
        isShowAlert,
        alertType,
        alertBody,
        showModal,
        toast,
        alertMessage,
        data,
        roleList,
        departmentList,
        errors,
        loading,
        toastState,
      } = this.state,
      { intl } = this.props,
      { direction } = this.props.language;
    return (
      <>
        {isShowAlert && (
          <Confirmation
            isConfirmation={false}
            onReject={() => this.setState({ isShowAlert: false })}
            show={isShowAlert}
            type={alertType}
            closeTime={2000}
            body={intl.formatMessage({ id: alertBody })}
            defaultDescription={intl.formatMessage({ id: alertBody })}
            title={intl.formatMessage({ id: alertBody })}
          />
        )}
        <Toast
          isOpen={toast}
          onClose={() => this.setState({ toast: false })}
          state={toastState}
          position="bottom"
          message={this.props.intl.formatMessage({
            id: alertMessage,
          })}
          direction={direction}
        />
        <Modal
          isOpen={showModal}
          onClose={() => this.setState({ showModal: false })}
          id="departmentManagement"
        >
          <DepartmentManagement
            profileId={this.props.id}
            updateDepartmentList={(isDepartmentUpdate) => {
              isDepartmentUpdate ? this.fetchDepartmentList() : null;
            }}
          />
        </Modal>
        <section className="col-12 px-responsive">
          <div className="px-0">
            <div className="invite-employee-container bg-white border p-4 default-border-radius-small ">
              <div className="col-12 px-0 d-flex flex-xs-row flex-column mb-sm-4 mb-xs-3 mb-2 pb-1">
                <div className="flex-grow-1 invite-form-container col-md-6 col-xs-7 col-12 px-md-3 px-0">
                  <div className="w-100 h-100 d-flex flex-row justify-content-start">
                    <img
                      className="img-fluid default-border-radius-small h-100 img-setup"
                      alt="add-personal"
                      src={require('../../../../content/images/elements/interview.png')}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-xs-5 col-12 px-md-3 px-xs-1 px-3 pt-xs-0 pt-3 d-flex flex-column justify-content-start align-items-start">
                  <span className="text-primary pt-md-5 pt-sm-4 pt-2 font-sm-xxlarge font-normal text-nowrap">
                    <FormattedMessage id="profile.inviteEmployees" />
                  </span>
                  <div className="col-md-10 w-100 text-third text-start pt-md-4 pt-sm-3 pt-1 px-0">
                    <p className="font-xl-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                      <FormattedMessage id="profile.textEmployees" />
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-grow-1 invite-form-container col-12">
                <div className="d-flex flex-wrap row pt-sm-2 pt-0">
                  <div className="col-sm-6 col-12 pb-2 pt-sm-0 pt-2">
                    <Input
                      name="userName"
                      label={intl.formatMessage({
                        id: `profile.username`,
                      })}
                      onChange={(event) =>
                        this.searchEmployee(event?.target?.value)
                      }
                      type={'text'}
                      value={data.email}
                      className={''}
                      themeMode="light"
                      outSideLabelClass="text-start"
                      outSideLabelPosition="top"
                      inputClassName={
                        'font-normal height-input-profile px-sm-3 px-3'
                      }
                      iconUrl={null}
                      outSideLabel={true}
                      tabIndex={'1'}
                    />
                    <ValidationMessage errors={errors?.userName} />
                  </div>
                  <div className={'col-sm-6 col-12 pb-2 pt-sm-0 pt-2'}>
                    <label className="w-100 text-start font-small text-primary px-3">
                      <FormattedMessage id="profile.fullname" />
                    </label>
                    <div
                      className="w-100 d-flex  justify-content-start align-items-center bg-third-light height-55px default-border-radius-small mb-sm-0 mb-4"
                      style={{
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'rgb(189, 198, 243)',
                        height: '3.45rem',
                      }}
                    >
                      <Tooltip
                        position={'top'}
                        content={data.fullName}
                        direction={direction}
                        backgroundColor="warning"
                        textColor="dark"
                        customClassName={'w-100 text-start'}
                      >
                        <span className="d-flex w-100 px-3 font-small text-truncate text-start">
                          {this.state.data.fullName ? (
                            <span className="w-100 text-success text-nowrap text-truncate">
                              {data.fullName}
                            </span>
                          ) : (
                            data.email !== '' && (
                              <span className="w-100 text-danger">
                                <FormattedMessage id="profile.notfound" />
                              </span>
                            )
                          )}
                        </span>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="col-sm-6 col-12 pt-sm-3 pt-2">
                    <Dropdown
                      classNames="bg-third-light height-55px"
                      name="departmentId"
                      id="departmentId"
                      label={'profile.department'}
                      value={data['departmentId']}
                      options={{
                        data: departmentList,
                        label: 'name',
                        value: 'id',
                        isMultiLanguage: true,
                      }}
                      onChange={this.handleChange}
                      theme="light"
                      outSideLabel={true}
                      iconNameDrp={null}
                      withoutShadow={true}
                      labelPosition="top"
                      maxHeight="55px"
                      outSideLabelClass={'dropDown-fontSize'}
                      tabIndex={'2'}
                    />
                    <div className="w-100 d-flex flex-row justify-content-between align-items-center pb-3">
                      <ValidationMessage errors={errors?.departmentId} />
                      <div className="font-small pt-2 px-3 department-link text-end">
                        <a
                          className={`cursor-pointer font-sm-msmall font-smaller text-nowrap`}
                          onClick={() => {
                            this.setState({ showModal: true });
                          }}
                        >
                          <FormattedMessage id="profile.addDepartment" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12 pt-sm-3 pt-2">
                    <label className="px-3 pb-2 text-start text-dark w-100 m-0 font-small">
                      <FormattedMessage
                        id="profile.employeeRole"
                        children={(msg) => <>{msg}</>}
                      />
                    </label>

                    <MultiSelectDropDown
                      name="roles"
                      label={''}
                      id="roleId"
                      data={roleList}
                      value={data?.roleName}
                      show="name"
                      send="id"
                      onClick={this.handleMultiSelectChange}
                      theme="light"
                      tabIndex={'3'}
                      classNameInput="height-input-profile"
                    />
                    <ValidationMessage errors={errors?.roleId} />
                  </div>
                  <div className="col-sm-6 col-12 pt-sm-0 pt-4 pb-3 mb-0">
                    <Input
                      name={'description'}
                      label={this.props.intl.formatMessage({
                        id: `profile.description`,
                      })}
                      onChange={this.handleChange}
                      type={'text'}
                      value={data['description']}
                      className={''}
                      themeMode="light"
                      // language
                      outSideLabelClass="text-start"
                      outSideLabelPosition="top"
                      iconUrl={null}
                      outSideLabel={true}
                      bottomClass="test"
                      inputClassName={
                        'font-normal height-input-profile px-sm-3 px-3'
                      }
                    />
                    <ValidationMessage errors={errors?.description} />
                  </div>
                  <div className="col-sm-6 col-12 pt-sm-0 pt-3 my-sm-0 my-3 d-flex flex-row justify-content-center align-items-center">
                    <Button
                      name={`send-invite`}
                      id={`send-invite`}
                      label={intl.formatMessage({
                        id: 'profile.sendingInvitation',
                      })}
                      className="btn-secondary mb-2"
                      disabled={!this.validate().result || loading}
                      loading={loading}
                      onClick={this.handleInviteEmployee}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
    user: state?.user?.userInfo ? state?.user?.userInfo : [],
  };
}

export default injectIntl(withRouter(connect(mapStateToProps)(InviteEmployee)));
